import { ref, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-70f8b822"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainpage"
};
const _hoisted_2 = {
  class: "card"
};
const _hoisted_3 = {
  key: 0,
  class: "back-box",
  style: {
    "margin-bottom": "12px"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" Aptoide商品配置 ")], -1));
const _hoisted_5 = {
  class: "optionLabel"
};
const _hoisted_6 = {
  class: "optionDescribtion"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "内购ID为 Aptoide 商品唯一标识，仅允许小写字母、数字、下划线(_)和句号(.)，创建后不可修改", -1));
const _hoisted_8 = {
  class: "card priceCard"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 价格设置 ")], -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "price-tip"
}, "Aptoide 将在用户购买时根据参考价格自动换算当地价格。", -1));
const _hoisted_11 = {
  class: "card"
};
const __default__ = {
  name: 'AptoideDetail'
};
import AptoideMultiComponents from './components/AptoideMultiComponents.vue';
import RecordDrawer from './components/RecordDrawer.vue';
import useDetailHooks from './hooks/useDetailHooks';
import { cloneDeep } from 'lodash';
import { queryPkgInfo, queryGoods, addGoods, updGoods, queryPriceList } from '@/api/goodsSetting';
import { useRoute, useRouter } from 'vue-router';
import { QuestionCircleOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { getNode, reportEvent } from '@/common';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const {
      huaweiProdTypeOptions,
      detailFormInit,
      validateAptoidePid,
      verifyNumber
    } = useDetailHooks();
    const nameRule = {
      placeholder: '商品名称，最多30字符',
      maxLength: 30
    }; // 商品名称规则
    const desRule = {
      placeholder: '商品描述，最多45字符',
      maxLength: 45
    }; // 商品描述规则
    const recordVisible = ref(false);
    const disabled = ref(false); // 禁用改动
    const queryParams = ref({
      prodChnl: '',
      dbtId: '',
      id: null // 商品主键
    });
    const saveNext = ref(false); // 是否连续创建，保存后留在本页并清空商品配置信息
    const multiComponentRef = ref(null); // 多语言组件ref
    const myFormRef = ref(null);
    const loading = ref(false);
    const saveLoading = ref(false); // 保存按钮可用性
    const priceLoading = ref(false); // 本地价格查询中，期间锁住价格输入框
    const nativePriceList = ref([]); // 各国本地价，页面不展示，仅随保存提交
    let pricePending = null; // 进行中的价格校验+查询，保存前需等它结束
    const buildInitForm = (preset = {}) => ({
      ...cloneDeep(detailFormInit),
      prodPriceCurrency: 'USD',
      pkg: preset.pkg || '',
      prodId: preset.pkg ? preset.pkg.toLowerCase() : '',
      defaultLang: preset.defaultLang || '',
      prodPrice: '',
      // 语言码由后端语言列表下发，这里不写死具体语言，交给组件按 defaultLang 落值
      productNativeInfo: [{
        lang: preset.defaultLang || '',
        langOptions: [],
        prodName: '',
        prodDescription: ''
      }]
    }); // 构造初始表单，用于新建与连续创建
    const settingForm = ref(buildInitForm());
    const getDetail = async () => {
      const res = await queryGoods({
        id: queryParams.value.id
      });
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        settingForm.value = {
          ...res.data,
          // 详情接口未回传默认语言时，沿用包信息接口下发的默认语言
          defaultLang: res.data.defaultLang || settingForm.value.defaultLang,
          prodPriceCurrency: 'USD'
        };
        nativePriceList.value = res.data.productNativePrice || [];
      }
    }; // 查询详情信息
    const getPkg = async () => {
      loading.value = true;
      const res = await queryPkgInfo({
        dbtId: queryParams.value.dbtId,
        prodChnl: queryParams.value.prodChnl
      });
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        settingForm.value.pkg = res.data.pkg;
        // 内购ID以包名为前缀预填，Aptoide 只接受小写，这里统一转小写避免包名带大写时校验不通过
        settingForm.value.prodId = res.data.pkg ? String(res.data.pkg).toLowerCase() : '';
        settingForm.value.defaultLang = res.data.defaultLang;
      }
      loading.value = false;
    }; // 查询包名等信息
    const setProdId = prodName => {
      var _toLowerCase$replace$, _myFormRef$value;
      if (queryParams.value.id) return; // 编辑时不允许修改内购ID
      const pkgStr = (settingForm.value.pkg || '').toLowerCase(); // 拼接前缀
      // Aptoide 内购ID只收小写字母、数字、下划线和句号，其余字符直接丢弃
      const nameStr = ((_toLowerCase$replace$ = (prodName || '').toLowerCase().replace(/\s*/g, '').match(/[a-z0-9_.]/g)) === null || _toLowerCase$replace$ === void 0 ? void 0 : _toLowerCase$replace$.join('')) || '';
      settingForm.value.prodId = nameStr ? `${pkgStr}.${nameStr}` : pkgStr;
      (_myFormRef$value = myFormRef.value) === null || _myFormRef$value === void 0 || _myFormRef$value.validateFields(['prodId']).catch(() => undefined);
    }; // 根据第一行商品名自动拼接内购ID：包名 + '.' + 商品名
    const onDefaultLangChange = lang => {
      settingForm.value.defaultLang = lang;
    }; // 第一行语言即默认语言，跟随组件变化并随保存提交
    const queryNativePrice = async () => {
      const prodPrice = settingForm.value.prodPrice;
      if (!prodPrice) {
        nativePriceList.value = [];
        return;
      }
      priceLoading.value = true;
      try {
        var _res$data;
        const res = await queryPriceList({
          pkg: settingForm.value.pkg,
          prodChnl: queryParams.value.prodChnl,
          prodPrice: parseFloat(prodPrice).toFixed(2),
          prodPriceCurrency: 'USD',
          prodType: settingForm.value.prodType,
          dbtId: queryParams.value.dbtId
        });
        nativePriceList.value = res.code === '0' ? ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.productNativePrice) || [] : [];
      } catch (error) {
        nativePriceList.value = [];
      } finally {
        priceLoading.value = false;
      }
    }; // 按默认价格拉取各国本地价，页面不展示，保存时随 productNativePrice 提交
    const callbackPrice = () => {
      var _nativePriceList$valu;
      // 与其它渠道一致：默认价格以本地价中的基准国（USD 对应美国）为准回写
      const basePrice = (_nativePriceList$valu = nativePriceList.value.filter(item => item.regionName === '美国')) === null || _nativePriceList$valu === void 0 || (_nativePriceList$valu = _nativePriceList$valu[0]) === null || _nativePriceList$valu === void 0 ? void 0 : _nativePriceList$valu.prodPrice;
      if (basePrice) {
        settingForm.value.prodPrice = basePrice;
      }
    }; // 价格列表回调
    const handlePriceChange = async () => {
      if (!settingForm.value.prodPrice) {
        message.warning('请先填写默认价格');
        nativePriceList.value = [];
        return;
      }
      if (parseFloat(settingForm.value.prodPrice) <= 0) {
        message.warning('默认价格必须大于0');
        settingForm.value.prodPrice = '';
        nativePriceList.value = [];
        return;
      }
      const flag = await verifyNumber({
        prodChnl: queryParams.value.prodChnl,
        prodPrice: settingForm.value.prodPrice,
        prodPriceCurrency: 'USD',
        prodType: settingForm.value.prodType
      });
      if (!flag) {
        settingForm.value.prodPrice = '';
        nativePriceList.value = [];
        return;
      }
      await queryNativePrice();
      callbackPrice();
    }; // 默认价格校验：非空、大于0、通过区间校验后拉取本地价并回写默认价
    const checkPrice = () => {
      // 失焦查询与保存点击是两个独立事件，这里留住 promise，
      // 保存时先 await 它，避免 addProduct 早于 getDefaultNativePrices 发出、漏掉本地价
      pricePending = handlePriceChange().finally(() => {
        pricePending = null;
      });
      return pricePending;
    }; // 默认价格失焦入口
    const cancel = () => {
      window.history.go(-1);
    }; // 取消逻辑
    const checker = () => {
      var _multiComponentRef$va, _multiComponentRef$va2;
      for (let i = 0; i < settingForm.value.productNativeInfo.length; i++) {
        var _item$prodName, _item$prodDescription;
        const item = settingForm.value.productNativeInfo[i];
        if (!item.lang || !item.prodName || !item.prodDescription) {
          message.error('商品信息的语言，商品名称，商品描述需要正确填写完整');
          return false;
        }
        if (((_item$prodName = item.prodName) === null || _item$prodName === void 0 ? void 0 : _item$prodName.length) > nameRule.maxLength) {
          item.error = `商品名称不能超过${nameRule.maxLength}个字符`;
        } else if (((_item$prodDescription = item.prodDescription) === null || _item$prodDescription === void 0 ? void 0 : _item$prodDescription.length) > desRule.maxLength) {
          item.error = `商品描述不能超过${desRule.maxLength}个字符`;
        } else {
          item.error = '';
        }
      }
      if (settingForm.value.productNativeInfo.filter(item => item.error).length) {
        return false;
      }
      const langList = settingForm.value.productNativeInfo.map(item => item.lang);
      if (new Set(langList).size !== langList.length) {
        message.error('同一商品不能重复配置相同语言');
        return false;
      }
      const supportedLangs = ((_multiComponentRef$va = multiComponentRef.value) === null || _multiComponentRef$va === void 0 || (_multiComponentRef$va2 = _multiComponentRef$va.getSupportedLangs) === null || _multiComponentRef$va2 === void 0 ? void 0 : _multiComponentRef$va2.call(_multiComponentRef$va)) || [];
      if (supportedLangs.length && langList.some(lang => !supportedLangs.includes(lang))) {
        message.error('存在当前渠道不支持的语言，请重新选择');
        return false;
      }
      return true;
    }; // 商品信息自定义校验
    const ensureNativePrice = async () => {
      // 等待失焦触发的校验+查询结束；若因先点保存而没赶上，这里再补一次
      if (pricePending) await pricePending;
      if (!settingForm.value.prodPrice) return false;
      if (!nativePriceList.value.length) {
        await checkPrice();
      }
      if (!settingForm.value.prodPrice || !nativePriceList.value.length) {
        message.error('本地价格获取失败，请检查默认价格后重试');
        return false;
      }
      return true;
    }; // 保证提交时 productNativePrice 已就绪
    const save = async () => {
      myFormRef.value.validate().then(async valid => {
        try {
          var _params$prodId;
          if (!valid) return;
          if (!checker()) return;
          if (!(await ensureNativePrice())) return;
          const fn = queryParams.value.id ? updGoods : addGoods;
          const params = {
            ...settingForm.value,
            prodChnl: queryParams.value.prodChnl,
            dbtId: queryParams.value.dbtId,
            prodPriceCurrency: 'USD',
            productNativePrice: nativePriceList.value
          };
          // 本期仅配置参考价格，不提交本地价格表与订阅方案
          delete params.prodBasePlan;
          delete params.prodGracePlan;
          if (params.pkg && params.pkg.toLowerCase() === ((_params$prodId = params.prodId) === null || _params$prodId === void 0 ? void 0 : _params$prodId.toLowerCase())) {
            message.error('内购ID不可完全等于包名，请手动补齐内购ID后半部分');
            return;
          }
          saveLoading.value = true;
          const res = await fn(params);
          saveLoading.value = false;
          if (res.code === '0') {
            message.success('商品保存成功！');
            if (!saveNext.value) {
              router.push({
                name: 'goodsSetting'
              });
            } else {
              var _myFormRef$value2;
              // 连续创建：留在本页，只保留包名与默认语言
              settingForm.value = buildInitForm({
                pkg: settingForm.value.pkg,
                defaultLang: settingForm.value.defaultLang
              });
              nativePriceList.value = [];
              (_myFormRef$value2 = myFormRef.value) === null || _myFormRef$value2 === void 0 || _myFormRef$value2.clearValidate();
            }
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: 'Aptoide商品配置',
                element_name: '保存'
              }
            });
          }
        } catch (error) {
          saveLoading.value = false;
        }
      });
    }; // 保存逻辑
    onMounted(async () => {
      queryParams.value = {
        ...route.query
      };
      if (route.query.type === 'watch') {
        disabled.value = true;
      }
      await getPkg();
      if (queryParams.value.id) {
        getDetail();
      }
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_skeleton_button = _resolveComponent("a-skeleton-button");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        ref_key: "myFormRef",
        ref: myFormRef,
        model: settingForm.value,
        "label-col": {
          style: 'width: 90px'
        },
        autocomplete: "off"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [queryParams.value.id ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = () => {
            _unref(router).back();
          })
        }, {
          default: _withCtx(() => [_createTextVNode(" 返回 ")]),
          _: 1
        }), _createElementVNode("div", {
          class: "record-text",
          onClick: _cache[1] || (_cache[1] = $event => recordVisible.value = true)
        }, "变更记录")])) : _createCommentVNode("", true), _hoisted_4, _createVNode(_component_a_form_item, {
          label: "商品类型",
          name: "prodType",
          rules: [{
            required: true,
            type: 'string'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            class: "inputer",
            value: settingForm.value.prodType,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => settingForm.value.prodType = $event),
            options: _unref(huaweiProdTypeOptions),
            placeholder: "请选择商品类型",
            disabled: disabled.value || !!queryParams.value.id,
            getPopupContainer: _unref(getNode)
          }, {
            option: _withCtx(({
              label,
              describtion
            }) => [_createElementVNode("div", _hoisted_5, _toDisplayString(label), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(describtion), 1)]),
            _: 1
          }, 8, ["value", "options", "disabled", "getPopupContainer"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "商品信息",
          rules: [{
            required: true
          }]
        }, {
          default: _withCtx(() => [loading.value ? (_openBlock(), _createBlock(_component_a_skeleton_button, {
            key: 0,
            active: "",
            block: "",
            style: {
              "width": "740px"
            }
          })) : (_openBlock(), _createBlock(AptoideMultiComponents, {
            key: 1,
            ref_key: "multiComponentRef",
            ref: multiComponentRef,
            filterItems: settingForm.value.productNativeInfo,
            disabled: disabled.value,
            "default-lang": settingForm.value.defaultLang,
            "prod-chnl": queryParams.value.prodChnl,
            nameRule: nameRule,
            desRule: desRule,
            onChangeDefaultLang: onDefaultLangChange,
            onSetProdId: setProdId
          }, null, 8, ["filterItems", "disabled", "default-lang", "prod-chnl"]))]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "内购ID",
          name: "prodId",
          rules: [{
            required: true,
            trigger: ['change', 'blur'],
            validator: _unref(validateAptoidePid)
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            class: "inputer",
            value: settingForm.value.prodId,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => settingForm.value.prodId = $event),
            placeholder: "请输入内购ID",
            disabled: Boolean(queryParams.value.id) || disabled.value
          }, null, 8, ["value", "disabled"]), _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_hoisted_7]),
            default: _withCtx(() => [_createVNode(_unref(QuestionCircleOutlined), {
              class: "infoIcon ml8"
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["rules"]), _createVNode(_component_a_form_item, {
          label: "备注"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            class: "bigInputer",
            value: settingForm.value.remark,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => settingForm.value.remark = $event),
            placeholder: "请输入",
            disabled: disabled.value,
            maxLength: 200
          }, null, 8, ["value", "disabled"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_a_form_item, {
          label: "默认价格",
          name: "prodPrice",
          rules: [{
            required: true
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input_number, {
            class: "priceInputer",
            value: settingForm.value.prodPrice,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => settingForm.value.prodPrice = $event),
            "addon-after": settingForm.value.prodPriceCurrency,
            step: 0.01,
            controls: false,
            precision: 2,
            "string-mode": "",
            disabled: disabled.value || priceLoading.value,
            placeholder: "请输入价格",
            onBlur: checkPrice
          }, null, 8, ["value", "addon-after", "step", "disabled"]), _hoisted_10]),
          _: 1
        })]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_a_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        }), _createVNode(_component_a_button, {
          class: "ml8",
          type: "primary",
          loading: saveLoading.value,
          disabled: disabled.value,
          onClick: save
        }, {
          default: _withCtx(() => [_createTextVNode(" 保 存 ")]),
          _: 1
        }, 8, ["loading", "disabled"]), !queryParams.value.id ? (_openBlock(), _createBlock(_component_a_checkbox, {
          key: 0,
          class: "ml8",
          checked: saveNext.value,
          "onUpdate:checked": _cache[6] || (_cache[6] = $event => saveNext.value = $event)
        }, {
          default: _withCtx(() => [_createTextVNode("连续创建")]),
          _: 1
        }, 8, ["checked"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["model"]), _createVNode(RecordDrawer, {
        visible: recordVisible.value,
        "onUpdate:visible": _cache[7] || (_cache[7] = $event => recordVisible.value = $event)
      }, null, 8, ["visible"])]);
    };
  }
});